// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Footer_copyright__2OWH4"};